import { Toast } from '../components';
import { useIzteachSessionStore } from '../stores/izteach';

// SSO failed but the QLT session is fine: say so without blocking anything. IZ screens keep their own signed-out state.
export function IzteachSsoNotice() {
  const failure = useIzteachSessionStore((state) => state.ssoFailure);
  const retry = useIzteachSessionStore((state) => state.signInWithQlt);
  const dismiss = useIzteachSessionStore((state) => state.dismissSsoFailure);
  if (!failure) return null;
  return (
    <Toast
      open={true}
      kind="warning"
      duration={0}
      message={`Chưa kết nối được IZTeach. ${failure.message}`}
      // a missing link is fixed by an admin, not by trying again
      onRetry={failure.needsLink ? undefined : () => { void retry(); }}
      onClose={dismiss}
    />
  );
}

export default IzteachSsoNotice;
